import React from "react";

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  <img src="/assets/images/loader.svg" alt="loader" width="100" height="100"/>
</div>;
export default CircularProgress;
